import { appealsConditions } from './conditions'
import { appealsScenarios } from './steps'
import { appealsTexts } from './texts'
import type { IOnboardingModule } from '../../types/IOnboardingModule'

export const appealsOnboarding: IOnboardingModule = {
  scenarios: appealsScenarios,
  texts: appealsTexts,
  conditions: appealsConditions,
}
